import Model from "./Model.js";

/**
 * Stores the credentials needed to initiate an e-conomic connection.
 *
 * @param {string} spec.agreementGrantToken - Agreement grant tooken provided by e-conomic
 * @param {string} spec.agreementNumber - Agreement number provided by e-conomic
 */

/**
 * TODO: write documentation
 */
export default class EconomicCredential extends Model {
	constructor(spec = {}) {
		super(spec);
		this._agreementGrantToken = spec.agreementGrantToken;
		this._agreementNumber = spec.agreementNumber;
	}

	haveCredentials() {
		return this._agreementNumber && this._agreementGrantToken;
	}

	getAgreementNumber() {
		return this._agreementNumber;
	}

	setAgreementNumber(agreementNumber) {
		this._agreementNumber = agreementNumber;
	}

	getAgreementGrantToken() {
		return this._agreementGrantToken;
	}

	setAgreementGrantToken(agreementGrantToken) {
		this._agreementGrantToken = agreementGrantToken;
	}

	_serializedProperties() {
		const schema = super._serializedProperties();

		schema.agreementGrantToken = this._agreementGrantToken;
		schema.agreementNumber = this._agreementNumber;

		return schema;
	}
}
